// extracted by mini-css-extract-plugin
export default {"priceCrossedOut":"Price-priceCrossedOut_FwK6W"};